import { Flow, Vertex } from '@/engine';
import { VertexMetadata } from 'simplex-flow-models';
import { MutationTree } from 'vuex'
import { FlowState } from './state'

export interface FlowMutations {
    ['setCurrentFlow'](state: FlowState, flow: Flow): void;
    ['setOptions'](state: FlowState, options: Record<string, any>): void;
    ['setSelectedVertex'](state: FlowState, vertex: Vertex | null): void;
    ['setVertexMetadata'](state: FlowState, vertexMetadata: Record<string, VertexMetadata>): void;
    ['setConnectorMetadata'](state: FlowState, data: Record<string, any>): void;
    ['setAvailableConnectors'](state: FlowState, data: Record<string, any>): void;
    ['setOpenApiOperations'](state: FlowState, data: Record<string, any>): void;
    ['setOpenApiOperationFields'](state: FlowState, data: Record<string, any>): void;
    ['setOpenApiServers'](state: FlowState, data: Record<string, any>): void;
    ['setOpenApiServerVariables'](state: FlowState, data: Record<string, any>): void;
    ['setCurrentFlowType'](state: FlowState, flowType: number | null): void;
}
export const flowMutations: MutationTree<FlowState> & FlowMutations = {
    ['setCurrentFlow'](state: FlowState, flow: Flow): void {
        state.currentFlow = flow;
    },
    ['setOptions'](state: FlowState, options: Record<string, any>): void {
        state.options = options;
    },
    ['setSelectedVertex'](state: FlowState, vertex: Vertex): void {
        state.selectedVertex = vertex;
    },
    ['setVertexMetadata'](state: FlowState, vertexMetadata: Record<string, VertexMetadata>): void {
        state.vertexMetadata = vertexMetadata;
    },
    ['setConnectorMetadata'](state: FlowState, data: Record<string, any>): void {
        if (!state.connectorMetadata) {
            state.connectorMetadata = {};
        } 
        if (!state.connectorMetadata[data.environment]) {
            state.connectorMetadata[data.environment] = {};
        }
        if (!state.connectorMetadata[data.environment][data.token]) {
            state.connectorMetadata[data.environment][data.token] = {};
        }
        state.connectorMetadata[data.environment][data.token][data.id] = data.connectorMetadata;
    },
    ['setAvailableConnectors'](state: FlowState, data: Record<string, any>): void {
        if (!state.availableConnectors) {
            state.availableConnectors = {};
        } 
        if (!state.availableConnectors[data.environment]) {
            state.availableConnectors[data.environment] = {};
        }
        if (!state.availableConnectors[data.environment][data.token]) {
            state.availableConnectors[data.environment][data.token] = {};
        }
        state.availableConnectors[data.environment][data.token]['updateConnectors'] = data.availableConnectors.updateConnectors;
        state.availableConnectors[data.environment][data.token]['getConnectors'] = data.availableConnectors.getConnectors;
    },
    ['setCurrentFlowType'](state: FlowState, flowType: number | null): void {
        state.currentFlowType = flowType;
    },
    ['setOpenApiOperations'](state: FlowState, data: Record<string, any>): void {
        if (!state.openApiOperations) {
            state.openApiOperations = {};
        }
        state.openApiOperations[data.url] = data.operations;
    },
    ['setOpenApiOperationFields'](state: FlowState, data: Record<string, any>): void {
        if (!state.openApiOperationFields) {
            state.openApiOperationFields = {};
        }
        if (!state.openApiOperationFields[data.url]) {
            state.openApiOperationFields[data.url] = {};
        }
        state.openApiOperationFields[data.url][data.operationId] = data.operationFields;
    },
    ['setOpenApiServers'](state: FlowState, data: Record<string, any>): void {
        if (!state.openApiServers) {
            state.openApiServers = {};
        }
        state.openApiServers[data.url] = data.servers;
    },
    ['setOpenApiServerVariables'](state: FlowState, data: Record<string, any>): void {
        if (!state.openApiServerVariables) {
            state.openApiServerVariables = {};
        }
        if (!state.openApiServerVariables[data.url]) {
            state.openApiServerVariables[data.url] = {};
        }
        state.openApiServerVariables[data.url][data.serverIndex] = data.variables;
    }
}
